export default __webpack_public_path__ + "static/jonas-helming-aca725b00f06acac10b198240c1b1f3b.jpg";